import React from 'react';

function MediaSkeleton({ count = 3, compact = false }) {
    return (
        <div className={compact ? 'grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4' : 'space-y-7'}>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    key={index}
                    className={`overflow-hidden rounded-2xl border border-slate-700/70 bg-slate-900/80 ${
                        compact ? '' : 'md:flex md:min-h-[250px]'
                    }`}
                >
                    <div className={`animate-pulse bg-slate-800 ${compact ? 'h-48 w-full' : 'h-52 w-full md:h-auto md:w-2/5'}`} />
                    <div className={`${compact ? 'p-5' : 'flex-1 p-6'} space-y-4`}>
                        <div className="h-3 w-28 animate-pulse rounded bg-slate-700" />
                        <div className="h-5 w-4/5 animate-pulse rounded bg-slate-700" />
                        <div className="h-4 w-full animate-pulse rounded bg-slate-800" />
                        <div className="h-4 w-3/4 animate-pulse rounded bg-slate-800" />
                        <div className="h-9 w-36 animate-pulse rounded-full bg-slate-800" />
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MediaSkeleton;
